import { atom } from 'jotai';

const filterUpdateStartedAtom = atom(false);

export { filterUpdateStartedAtom };
